import React, { useEffect, useState } from 'react'
import { Container, Grow, Grid } from '@material-ui/core'

import PasswordForm from '../Form/PasswordForm'
const Password = ({ checkLogin }) => {
  let [checkLogin2, setCheckLogin] = useState(false)
  function handleState(newValue) {
    setCheckLogin(newValue)
    checkLogin(newValue)
  }
  return (
    <Grow in>
      <Container>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12} sm={12}>
            <PasswordForm checkLogin={handleState} />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default Password
